"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.object.set-prototype-of.js");

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.object.create.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZeplinApi = void 0;

require("core-js/modules/es.object.define-property.js");

var _axios = _interopRequireDefault(require("axios"));

var _base = require("./base");

var _authorizationApi = require("./apis/authorization-api");

var _colorsApi = require("./apis/colors-api");

var _componentsApi = require("./apis/components-api");

var _connectedComponentsApi = require("./apis/connected-components-api");

var _designTokensApi = require("./apis/design-tokens-api");

var _flowsApi = require("./apis/flows-api");

var _notificationsApi = require("./apis/notifications-api");

var _organizationsApi = require("./apis/organizations-api");

var _projectsApi = require("./apis/projects-api");

var _screensApi = require("./apis/screens-api");

var _spacingApi = require("./apis/spacing-api");

var _styleguidesApi = require("./apis/styleguides-api");

var _textStylesApi = require("./apis/text-styles-api");

var _usersApi = require("./apis/users-api");

var _webhooksApi = require("./apis/webhooks-api");

var _webhooks = require("./utilities/webhooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ZeplinApi = /*#__PURE__*/function (_BaseAPI) {
  _inherits(ZeplinApi, _BaseAPI);

  var _super = _createSuper(ZeplinApi);

  function ZeplinApi(configuration) {
    var _this;

    var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _base.BASE_PATH;
    var axios = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _axios["default"];

    _classCallCheck(this, ZeplinApi);

    _this = _super.call(this, configuration, basePath, axios);
    _this.basePath = basePath;
    _this.axios = axios;
    _this.authorization = new _authorizationApi.AuthorizationApi(configuration, basePath, axios);
    _this.colors = new _colorsApi.ColorsApi(configuration, basePath, axios);
    _this.components = new _componentsApi.ComponentsApi(configuration, basePath, axios);
    _this.connectedComponents = new _connectedComponentsApi.ConnectedComponentsApi(configuration, basePath, axios);
    _this.designTokens = new _designTokensApi.DesignTokensApi(configuration, basePath, axios);
    _this.flows = new _flowsApi.FlowsApi(configuration, basePath, axios);
    _this.notifications = new _notificationsApi.NotificationsApi(configuration, basePath, axios);
    _this.organizations = new _organizationsApi.OrganizationsApi(configuration, basePath, axios);
    _this.projects = new _projectsApi.ProjectsApi(configuration, basePath, axios);
    _this.screens = new _screensApi.ScreensApi(configuration, basePath, axios);
    _this.spacing = new _spacingApi.SpacingApi(configuration, basePath, axios);
    _this.styleguides = new _styleguidesApi.StyleguidesApi(configuration, basePath, axios);
    _this.textStyles = new _textStylesApi.TextStylesApi(configuration, basePath, axios);
    _this.users = new _usersApi.UsersApi(configuration, basePath, axios);
    _this.webhooks = new _webhooksApi.WebhooksApi(configuration, basePath, axios);
    return _this;
  }

  return ZeplinApi;
}(_base.BaseAPI);

exports.ZeplinApi = ZeplinApi;

_defineProperty(ZeplinApi, "Webhooks", _webhooks.Webhooks);